import { Component, Host, h, Prop, getAssetPath } from "@stencil/core";
import type { Color } from "../../utils/types";

@Component({
	tag: "smart-icon",
	styleUrl: "smart-icon.scss",
	assetsDirs: ["assets"]
})
export class SmartIcon {
	@Prop({reflect: true}) phosphorIcon: string = undefined;
	@Prop() color: Color;
	@Prop({reflect: true}) customIconName: string = undefined;
	@Prop() rotate: "left" | "right" | "down" | "up" = "left";
	@Prop() weight: "thin" | "light" | "regular" | "bold" | "fill" | "duotone" = "regular";
	@Prop() size!: number;

	private icons = {
		visa: getAssetPath("./assets/visa.svg"),
		mastercard: getAssetPath("./assets/mastercard.svg"),
		hipercard: getAssetPath("./assets/hipercard.svg"),
		express: getAssetPath("./assets/express.svg"),
		elo: getAssetPath("./assets/elo.svg"),
		diners: getAssetPath("./assets/diners.svg")
	};

	render() {

		if(this.phosphorIcon !== undefined && this.phosphorIcon !== "undefined"){
			return (  
				<i part="icon-element" class={`ph-bold ${this.phosphorIcon}`} 
					style={{
						"display": "flex",
						"color": this.color,
						"font-size": `${this.size.toString()}px`
					}}></i>
			);
		}

		if(this.customIconName !== undefined && this.customIconName !== "undefined"){
			return (
				<Host part="icon-element">
					<img src={this.icons[this.customIconName]}/>
				</Host>
			);
		}
	}
}
